<template>
  <div v-if="credits.length" class="layer-credits" @click="toggleAboutDrawer">
    <div v-for="(c, i) in credits" :key="i" class="credit-item">{{ c }}</div>
  </div>
</template>

<script>
function extractCredit(attribution) {
  if (!attribution) return ''
  return attribution
    .replace(/<[^>]+>/g, ' ')
    .replace(/&copy;/g, '©')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export default {
  name: 'LayerCredits',
  props: {
    mapName: {
      type: String,
      default: 'map01',
    },
  },
  methods: {
    toggleAboutDrawer() {
      this.$store.commit('setAboutDrawer', !this.$store.state.showAboutDrawer)
    },
  },
  computed: {
    credits() {
      const layers = this.$store.state.selectedLayers[this.mapName] || []
      const seen = new Set()
      const result = []
      for (const layer of layers) {
        const credit = layer.credit || extractCredit(layer.attribution)
        if (credit && !seen.has(credit)) {
          seen.add(credit)
          result.push(credit)
        }
      }
      return result
    },
  },
}
</script>

<style scoped>
.layer-credits {
  position: absolute;
  bottom: 4px;
  right: 4px;
  z-index: 1;
  pointer-events: auto;
  cursor: pointer;
  text-align: right;
  max-width: 60%;
}
.credit-item {
  font-size: 10px;
  line-height: 1.3;
  color: rgba(0, 0, 0, 0.6);
  text-shadow:
    0 0 3px rgba(255, 255, 255, 0.9),
    0 0 3px rgba(255, 255, 255, 0.9);
}
</style>
